<template>
  <div class="projectRegisterPage" v-if="!this.showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="projectData.projectName"
        :required="editType"
        :disabled="!editType"
        :placeholder="editType ? '请输入...  ' : ''"
        label="项目名称："
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone">
      <van-field
        v-model="projectStatusName"
        :required="editType"
        label="项目状态："
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkProjectTypePicker"
        readonly
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="biddingTypeName"
        label="项目承接方式："
        :required="editType"
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkBiddingPicker"
        readonly
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone">
      <van-field
        v-model="projectLxName"
        label="项目性质："
        :required="editType"
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkProjectLxPicker"
        readonly
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone">
      <van-field
        v-model="projectDlName"
        label="项目大类："
        :required="editType"
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkProjectDlPicker"
        readonly
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="projectXfName"
        label="项目细分："
        :required="editType"
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkProjectXfPicker"
        readonly
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone">
      <van-field
        v-model="projectNodeNames"
        label="项目进度："
        :required="editType"
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkProjectJdPicker"
        rows="1"
        autosize
        type="textarea"
        readonly
      />
      <p class="smallText red" v-if="editType">
        提示:
        请选择项目实施中可能包含的所有节点，后续项目进度从当前选择的节点中更新，错选或漏选将影响后续项目进度更新
      </p>
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone">
      <van-field
        v-model="regionShengName"
        label="省级区域："
        :required="editType"
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkShengPicker"
        readonly
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone">
      <van-field
        v-model="regionShiName"
        label="市级区域："
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkShiPicker"
        readonly
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone">
      <van-field
        v-model="regionXianName"
        label="县级区域："
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkXianPicker"
        readonly
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="projectData.ownerCompany"
        :required="editType"
        :placeholder="editType ? '请输入...  ' : ''"
        label="业主单位："
        :disabled="!editType"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        v-model="projectData.projectAmount"
        :required="editType"
        :disabled="!editType"
        type="number"
        :placeholder="editType ? '请输入...  ' : ''"
        label="项目金额（元）："
        class="ggInput"
        @input="checkHzf"
        @blur="getPercentConfig"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        v-model="projectData.kpiAmount"
        :required="editType"
        :disabled="!editType"
        type="number"
        :placeholder="editType ? '请输入...  ' : ''"
        label="业绩指标金额（元）："
        class="ggInput"
      />
    </van-cell-group>
    <!-- 新增内容 -->
    <!-- <van-cell-group class="baseSalary baseNone moreText">
                                              <van-field
                                                v-model="projectData.interiorPercent"
                                                label="内业比例（%）："
                                                :required="editType"
                                                :disabled="!editType"
                                                :placeholder="editType ? '请输入...  ' : ''"
                                                type="number"
                                                @input="getExteriorPercent"
                                              />
                                            </van-cell-group>
                                            <van-cell-group class="baseSalary baseNone moreText">
                                              <van-field
                                                v-model="projectData.exteriorPercent"
                                                label="外业比例（%）："
                                                :required="editType"
                                                :disabled="!editType"
                                                readonly
                                                type="number"
                                              />
                                            </van-cell-group> -->
    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="projectData.marketPercent"
        label="营销成本比例（%）："
        :required="editType"
        disabled
        type="number"
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="projectData.technologyPercent"
        label="技术成本比例（%）："
        :required="editType"
        disabled
        type="number"
      />
    </van-cell-group>

    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="projectData.receptionPercent"
        label="招待费用比例（%）："
        :required="editType"
        disabled
        type="number"
      />
    </van-cell-group>

    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="projectData.marketBonusPercent"
        label="营销提成比例（%）："
        :required="editType"
        :disabled="!editType"
        :placeholder="editType ? '请输入...  ' : ''"
        type="number"
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="projectData.technologyBonusPercent"
        label="技术提成比例（%）："
        :required="editType"
        :disabled="!editType"
        :placeholder="editType ? '请输入...  ' : ''"
        type="number"
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="projectData.cooperationAmount"
        label="商务费（元）："
        :required="editType"
        :disabled="!editType"
        :placeholder="editType ? '请输入...  ' : ''"
        @input="checkHzf"
        @blur="getPercentConfig"
        type="number"
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="projectData.laborAmount"
        label="技术协作费（元）："
        :required="editType"
        :disabled="!editType"
        :placeholder="editType ? '请输入...  ' : ''"
        @input="checkHzf"
        @blur="getPercentConfig"
        type="number"
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="projectData.purchaseAmount"
        label="硬件采购费（元）："
        :required="editType"
        :disabled="!editType"
        :placeholder="editType ? '请输入...  ' : ''"
        @input="checkHzf"
        @blur="getPercentConfig"
        type="number"
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="isDiversionName"
        label="是否内部外调："
        :required="editType"
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkIsTypePicker('waidiao')"
        readonly
      />
    </van-cell-group>

    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        v-model="projectData.diversionAmount"
        :required="editType"
        :disabled="!editType"
        type="number"
        label="内部外调费（元）："
        class="ggInput"
        @input="checkHzf"
        @blur="getPercentConfig"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        v-model="projectData.proportion"
        :required="editType"
        disabled
        type="number"
        label="我方项目分配比例（%）："
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        v-model="projectData.ownerContact"
        :required="editType"
        :placeholder="editType ? '请输入...  ' : ''"
        label="业主联系人："
        :disabled="!editType"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        v-model="projectData.ownerMobile"
        @blur="checkPhone"
        type="tel"
        label="联系电话："
        maxlength="11"
        :required="editType"
        :disabled="!editType"
        :placeholder="editType ? '请输入...  ' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="projectData.headName"
        label="项目负责人："
        :required="editType"
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkRedioRetinuePicker('headName')"
        readonly
      />
    </van-cell-group>
    <van-cell-group
      class="baseSalary baseNone selectCyMain"
      v-if="(!editType && moreRetinueList.length > 0) || editType"
    >
      <!-- 项目成员 多选 -->
      <van-field
        v-model="memberNames"
        label="项目成员："
        class="ggInput"
        readonly
      />
      <div class="cyListBox clearfix">
        <ul class="fl">
          <li v-for="item in moreRetinueList" :key="item.id" class="cyList">
            <dl>
              <dt>
                <van-image width="45" height="45" :src="item.avatar" cover />
              </dt>
              <dd>{{ item.realName }}</dd>
              <dd class="delStaff" @click="delStaff(item)" v-if="editType">
                x
              </dd>
            </dl>
          </li>
          <li
            class="addBtn"
            @click="checkMoreRetinuePicker('memberNames')"
            v-if="editType"
          >
            <dl>
              <dt><img :src="baseUrl + 'img/addBtn.png'" alt /></dt>
              <dd>添加</dd>
            </dl>
          </li>
        </ul>
      </div>
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone moreText undertakeBox ">
      <van-field v-model="baseNone" label="项目承接人：" class="van-cell--required" readonly />
      <van-button
        type="info"
        icon="plus"
        size="small"
        @click="checkMoreRetinuePicker('firstContactName')"
        class="addBtn"
        v-if="editType"
        >添加</van-button
      >
      <div class="undertakeInfo">
        <div class="undertakeList" v-if="projectData.undertakeList[0]">
          <div
            class="undertakeItem"
            v-for="(item, index) in projectData.undertakeList"
            :key="item.uid"
          >
            <van-field
              v-model="item.realName"
              label="承接人名称:"
              readonly
              input-align="right"
            />
            <van-field
              v-model="item.proportion"
              label="承接人比例(%):"
              placeholder="请输入项目承接人比例"
              input-align="right"
            />
            <div class="delBtn" @click="delUndertakeItem(index)"   v-if="editType">
              <van-icon name="cross" />
            </div>
          </div>
        </div>
      </div>
    </van-cell-group>

    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        label="项目开始日期："
        :required="editType"
        readonly
        clearable
        v-model="projectData.startDate"
        @click="TimePicker(1)"
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        label="预计项目结束日期："
        :required="editType"
        readonly
        v-model="projectData.expectedFinishDate"
        @click="TimePicker(2)"
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="isAuditName"
        label="是否需要内审："
        :required="editType"
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        readonly
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="isReviewName"
        label="是否需要评审："
        :required="editType"
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        readonly
      />
    </van-cell-group>

    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="isPerformance"
        label="是否履约保证金："
        :required="editType"
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkIsTypePicker(3)"
        readonly
      />
    </van-cell-group>

    <van-cell-group
      class="baseNone baseSalary moreText"
      v-if="(!editType && projectData.bondAmount) || editType"
    >
      <van-field
        v-model="projectData.bondAmount"
        label="履约保证金金额（元）："
        :placeholder="editType ? '请输入...  ' : ''"
        class="ggInput"
        :disabled="!editType"
        type="number"
      />
    </van-cell-group>

    <!-- 审批流程 -->
    <div
      class="approveList"
      v-if="mode !== 'add' && projectData.verifyStatus != 'hold'"
    >
      <audit-list :applicantData="projectData"></audit-list>
    </div>
    <!-- 当前审核人 -->
    <div
      v-if="mode !== 'add' && projectData.verifyStatus != 'hold' && verifyName"
    >
      <p class="tit">当前审核人</p>

      <van-cell-group class="baseNone baseSalary moreText">
        <div class="van-cell">{{ verifyName }}</div>
      </van-cell-group>
    </div>
    <!-- 流程图 -->
    <div
      class="flowList"
      v-if="
        mode !== 'add' &&
        projectData.verifyStatus != 'hold' &&
        projectData.flowType == '1'
      "
    >
      <flow-staff :applicantData="projectData"></flow-staff>
      <flow-list :workflowCode="projectData.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <!-- 老的审批 -->
    <van-popup
      v-model="verifyPageType"
      v-if="projectData.flowType == '0'"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <div style="position: relative; z-index: 9999999">
        <verify-project
          :applicantData="projectData"
          @changeVerifyType="setVerifyType"
        ></verify-project>
      </div>
    </van-popup>
    <!-- 新的审批 -->
    <van-popup
      v-model="verifyPageType"
      v-if="projectData.flowType == '1'"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main
        :applicantData="projectData"
        @changeVerifyType="setVerifyType"
      ></verify-main>
    </van-popup>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput('add')"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <div v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="projectData.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput('edit')"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="projectData.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput('edit')"
          >再次提交</van-button
        >
      </div>
    </div>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        projectData.verifyStatus == 'pending' &&
        mode != 'verify' &&
        mode != 'view' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          projectData.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          projectData.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">审批</van-button>
    </div>
    <!-- 审批撤回按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' || mode == 'view') &&
        verifyType != '1' &&
        isVerifyRecall &&
        projectData.flowType == '1'
      "
    >
      <van-button type="info" :loading="btnLoading" @click="verifyRecall"
        >撤回</van-button
      >
    </div>

    <!-- 弹出层 -->
    <van-popup v-model="projectTypePicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="dictName"
        :columns="projectStatusColumns"
        @cancel="projectTypePicker = false"
        @confirm="onSaveProjectType"
      />
    </van-popup>
    <!-- 省 市 县 联动 -->
    <!-- 省  联动 -->
    <van-popup v-model="regionShengPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="regionName"
        :columns="regionShengList"
        @cancel="regionShengPicker = false"
        @confirm="onSaveShengCode"
      />
    </van-popup>
    <!-- 市 联动 -->
    <van-popup v-model="regionShiPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="regionName"
        :columns="regionShiList"
        @cancel="regionShiPicker = false"
        @confirm="onSaveShiCode"
      />
    </van-popup>
    <!-- 县 联动 -->
    <van-popup v-model="regionXianPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="regionName"
        :columns="regionXianList"
        @cancel="regionXianPicker = false"
        @confirm="onSaveXianCode"
      />
    </van-popup>
    <!-- 项目类型联动 -->
    <van-popup v-model="projectLxPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="dictName"
        :columns="projectLxList"
        @cancel="projectLxPicker = false"
        @confirm="onSaveProjectLx"
      />
    </van-popup>
    <van-popup v-model="projectDlPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="dictName"
        :columns="projectDlList"
        @cancel="projectDlPicker = false"
        @confirm="onSaveProjectDl"
      />
    </van-popup>
    <van-popup v-model="projectXfPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="dictName"
        :columns="projectXfList"
        @cancel="projectXfPicker = false"
        @confirm="onSaveProjectXf"
      />
    </van-popup>
    <!-- 招标方式 -->
    <van-popup v-model="biddingTypePicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="dictName"
        :columns="biddingList"
        @cancel="biddingTypePicker = false"
        @confirm="onSaveBiddingType"
      />
    </van-popup>
    <!-- 时间控件 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
    <!-- 是否需要审核 -->
    <van-popup v-model="isTypePicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="dictName"
        :columns="isTypeList"
        @cancel="isTypePicker = false"
        @confirm="onIsTypeConfirm"
      />
    </van-popup>
    <!-- 选择项目负责人 -->
    <van-popup
      v-model="showRedioRetinuePicker"
      position="bottom"
      class="roleBox"
    >
      <redio-retinue-view
        :retinueUid="projectData.head"
        @setReview="setRedioRetinue"
      ></redio-retinue-view>
    </van-popup>
    <!-- 选择项目成员/ 选择项目承接人 -->
    <van-popup
      v-model="showMoreRetinuePicker"
      position="bottom"
      class="roleBox"
    >
      <!-- 项目成员 -->
      <more-retinue-view
        v-if="moreSelectType == 'memberNames'"
        :retinueUids="projectData.member"
        @moreSetReview="setMoreRetinue"
      ></more-retinue-view>
      <!-- 项目承接人 -->
      <more-people-view
        v-else
        :staffIds="undertakeIds"
        :reloadType="reloadType"
        @closeStaff="closeStaffPage"
        @moreSetStaff="setMoreStaff"
      ></more-people-view>
    </van-popup>
    <!-- 选择项目进度 -->
    <van-popup v-model="proportionFlag" position="bottom" class="roleBox">
      <more-proportion-view
        :staffIds="projectData.projectNode"
        @closeProportion="closeProportionPage"
        @moreSetProportion="setMoreProportion"
      ></more-proportion-view>
    </van-popup>
  </div>
</template>

<script>
/*eslint-disable*/
const redioRetinueView = () =>
  import("@/components/businessTripMould/redioRetinueView");
const moreRetinueView = () =>
  import("@/components/businessTripMould/moreRetinueView");
const morePeopleView = () =>
  import("@/views/projectModule/components/moreSelectPeople");
const moreProportionView = () =>
  import("@/views/projectModule/components/moreSelectProportion");
const fileView = () => import("@/components/common/fileView");
const flowList = () => import("@/components/common/flowList");
const flowStaff = () => import("@/components/common/flowStaff");
const auditList = () => import("@/components/common/auditList");
const verifyProject = () => import("@/components/common/verifyProject");
const verifyMain = () => import("@/components/common/verifyMain");
import { mapState, mapMutations } from "vuex";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
import { dateTimeFormat } from "@/utils/common";
export default {
  name: "projectRegister",
  components: {
    redioRetinueView,
    moreRetinueView,
    morePeopleView,
    moreProportionView,
    fileView,
    auditList,
    flowList,
    verifyProject,
    flowStaff,
    verifyMain,
  },
  data() {
    return {
      isVerifyRecall: "", //是否能撤回操作
      verifyName: "", //当前审核人
      baseUrl: process.env.BASE_URL,
      commonType: "",
      commonId: "",
      baseNone: "", //空字段
      projectData: {
        id: "",
        bondAmount: "", //履约保证金金额
        isPerformanceBond: "", //是否履约保证金
        projectName: "", //项目名称
        projectStatus: "", //项目状态
        projectAmount: "", //项目金额
        kpiAmount:"",//业绩指标金额
        proportion: "", //项目分配比例
        regionCode: "", //区域编码
        regionLevel: "", //区域级别
        regionName: "", //地区名
        projectType: "", //项目类型
        mainClass: "", //项目大类
        projectNode: [], //项目进度配置
        subClass: "", //项目类型细分
        interiorPercent: "99", //内页比例
        exteriorPercent: "1", //外业比例
        marketPercent: "", //营销成本比例
        technologyPercent: "", //技术成本比例
        receptionPercent: "", //招待成本比例
        marketBonusPercent:"",//营销提成比例
        technologyBonusPercent:"",//技术提成比例
        cooperationAmount: "", //商务费
        laborAmount: "", //技术协作费
        purchaseAmount: "", //硬件采购费
        isDiversion: "false", //是否内部外调
        diversionAmount: "", //内部外调费
        biddingType: "", //招标方式(zb:招标 shwt:社会委托 qt:其他
        startDate: "", //项目开始时期
        expectedFinishDate: "", //预计结束日期
        isAudit: "true", //是否需要内审
        isReview: "true", //是否需要评审
        head: "", //项目负责人Id
        headName: "", //项目负责人名称
        member: [], //项目成员ids
        ownerCompany: "", //业主单位
        ownerContact: "", //业主联系人
        ownerMobile: "", //联系电话
        firstContact: [], //业主第一次联系人
        firstContactName: "", //业主第一次联系人
        undertakeList: [], //项目承接人占比入参
        ownerFirstTime: "", //业主第一次联系日期
        verifyStatus: "hold", //审核状态(VerifyStatus)：pending,待审核;doing,审核中;pass,通过;deny,拒绝
      },
      undertakeIds: [], //项目承接人id
      projectNodeNames: "",
      memberNames: "",
      isAuditName: "是",
      isReviewName: "是",
      isDiversionName: "否",
      isPerformance: "", //是否履约保证金
      checkWhetherIndex: "", //获取内审Type和评审Type
      isTypePicker: false,
      isTypeList: [
        { dictName: "是", dictCode: true },
        { dictName: "否", dictCode: false },
      ],
      biddingTypeName: "", //招标方式名称
      biddingList: [], //招标方式List
      biddingTypePicker: false,
      projectStatusColumns: [],
      projectStatusName: "",
      showTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(2018, 0, 1),
      checkTimeIndex: "", // 获取项目开始和结束时间
      projectLxName: "", //项目类型名称
      projectLxPicker: false,
      projectLxList: [],
      projectDlName: "", //项目大类名称
      projectDlPicker: false,
      projectDlList: [],
      projectXfName: "", //项目细分名称
      projectXfPicker: false,
      projectXfList: [],
      projectTypePicker: false,
      regionShengName: "",
      regionShiName: "",
      regionXianName: "",
      regionShengCode: "",
      regionShiCode: "",
      regionShengPicker: false, //选择省区域联动
      regionShengList: [],
      regionShiPicker: false, //选择市区域联动
      regionShiList: [],
      regionXianPicker: false, //选择县/区域联动
      regionXianList: [],
      moreSelectType: "",
      reloadType: "1",
      showRedioRetinuePicker: false, // 项目负责人弹框
      showMoreRetinuePicker: false, //项目成员弹框
      moreRetinueList: [], //返回的项目成员数组
      peopleMoreType: "",
      proportionFlag: false, //项目进度弹框
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      mode: "add",
      editType: false,
      sendType: "", //判断是否在抄送列表
      peopleRedioType: "", //选择单选人员的类型
      clientType: getDeviceType(), //手机类型
      changeNumType: "1",
    };
  },
  mounted() {
    document.title = "项目登记申请";
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.editType = this.mode == "add" ? true : false;
    this.commonId = this.$route.query.commonId; //申请Id
    window.editPage = this.editPage; //调用编辑
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    window.sessionStorage.setItem("moreRetinueList", JSON.stringify([]));
    window.sessionStorage.setItem("morePeopleList", JSON.stringify([]));
    this.$nextTick(function () {
      this.editType = this.mode == "add" ? true : false;
      this.setShowLoad(false); //加载状态，默认为true加载
      this.getShengList();
      this.getProjectLxList(1, "HTXMLX");
      this.getZbfsList();
      this.getProjectType();
      // if (this.mode == "add" && this.userinfo && this.userinfo.id) {
      //     this.projectData.firstContact.push(this.userinfo.id);

      //     this.$set(this.projectData, "firstContactName", this.userinfo.realName);
      //     console.log(this.projectData.firstContact, "firstContact");
      //     window.sessionStorage.setItem(
      //         "morePeopleList",
      //         JSON.stringify(this.projectData.firstContact)
      //     );
      // }
      this.mode !== "add" ? (this.commonId ? this.getDetails() : "") : "";
      (this.mode == "verify" || this.mode == "view") && this.verifyType != "1"
        ? this.commonId
          ? this.checkRecall()
          : ""
        : "";
    });
    this.mode == "add" ? this.getMoreTest() : "";
  },
  methods: {
    getMoreTest() {
      let _this = this;

      _this.$api.project.configList(1, 999999, { status: true }).then((res) => {
        let id = [];
        if (res.code == "1") {
          res.data.list.forEach((item) => {
            if (item.isDefault) {
              id.push(item.id);
            }
          });
          _this.projectData.projectNode = id;
        } else {
          console.log(res.msg);
        }
      });
    },
    ...mapMutations(["setShowLoad"]),
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    editPage() {
      //需要编辑
      this.editType = true;
    },

    //判断当前是否能撤回操作
    checkRecall() {
      let _this = this;
      _this.$api.project.checkRecall(_this.commonId).then((res) => {
        if (res.code == "1" && res.data != null) {
          _this.isVerifyRecall = res.data;
        } else {
          _this.$toast(res.msg);
        }
      });
    },
    //撤销审核
    verifyRecall() {
      let _this = this;
      _this.$dialog
        .confirm({
          title: "确认撤回审核",
          message: "您确认要撤回当前审核?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.project
            .backProjectApply("verify", _this.projectData.id)
            .then((res) => {
              if (res.code == "1") {
                let text = "撤回审核成功";
                if (is_wei()) {
                  _this.$toast(text);
                  _this.isVerifyRecall = false;
                } else {
                  closePage(text);
                }
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              _this.$toast("网络失败，稍后重试22");
              _this.btnLoading = false;
            });
        });
    },
    //获取当前审核人
    getAuditUser() {
      let _this = this;
      _this.$api.project
        .getAuditUser({
          id: _this.commonId,
          verifyStatus: _this.projectData.verifyStatus,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.verifyName = res.data;
          }
        });
    },
    //获取详情
    getDetails() {
      let _this = this;
      _this.$api.project
        .detailProjectApply({ projectId: this.commonId })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.projectData = res.data;
            _this.isAuditName = _this.projectData.isAudit ? "是" : "否";
            _this.isReviewName = _this.projectData.isReview ? "是" : "否";
            _this.isDiversionName = _this.projectData.isDiversion ? "是" : "否";
            _this.isPerformance = _this.projectData.isPerformanceBond
              ? "是"
              : "否";
            _this.moreRetinueList = res.data.memberNames;
            window.sessionStorage.setItem(
              "moreRetinueList",
              JSON.stringify(res.data.memberNames)
            );
            _this.projectStatusName = _this.projectData.projectStatusName;
            _this.projectLxName = _this.projectData.projectTypeName;
            _this.projectDlName = _this.projectData.mainClassName;
            _this.projectXfName = _this.projectData.subClassName;
            _this.biddingTypeName = _this.projectData.biddingTypeName;
            _this.regionShengName = _this.projectData.shengName;
            _this.regionShiName =
              _this.projectData.shiName == null
                ? ""
                : _this.projectData.shiName;
            _this.regionXianName =
              _this.projectData.xianName == null
                ? ""
                : _this.projectData.xianName;

            if (_this.regionShengName) {
              _this.regionShengCode =
                _this.projectData.regionCode.substring(0, 2) + "0000000000";
              _this.getShiList();
            }
            if (_this.regionShiName) {
              _this.regionShiCode =
                _this.projectData.regionCode.substring(0, 4) + "00000000";
              this.getXianList();
            }

            _this.getAuditUser();
            // window.sessionStorage.setItem(
            //   "morePeopleList",
            //   JSON.stringify(res.data.firstContact)
            // );
            if (res.data.projectNode.length > 0) {
              let nodeNames = [],
                nodeIds = [];
              res.data.projectNode.forEach((item) => {
                nodeNames.push(item.stageName);
                nodeIds.push(item.id);
              });
              _this.projectNodeNames = nodeNames.join(",");
              _this.projectData.projectNode = nodeIds;
            } else {
              _this.projectNodeNames = "";
            }
            // this.editType = true;
            if (
              (_this.projectData.verifyStatus == "hold" ||
                _this.projectData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          }
        })
        .catch((err) => {
          this.$toast("网络错误, 请稍后再试");
        });
    },

    checkProjectTypePicker() {
      if (this.editType) {
        this.projectTypePicker = true;
      }
    },
    onSaveProjectType(data) {
      this.projectTypePicker = false;
      this.projectData.projectStatus = data.dictCode;
      this.projectStatusName = data.dictName;
    },
    checkShengPicker() {
      if (this.editType) {
        this.regionShengPicker = true;
      }
    },
    onSaveShengCode(data) {
      this.projectData.regionCode = data.code;
      this.projectData.regionLevel = data.levels;
      this.projectData.regionName = data.regionName;
      this.regionShengCode = data.code;
      this.regionShengName = data.regionName;
      this.regionShengPicker = false;
      this.regionShiCode = "";
      this.regionShiName = "";
      this.regionXianCode = "";
      this.regionXianName = "";
      this.getShiList();
    },
    checkShiPicker() {
      if (this.editType) {
        if (this.regionShengCode) {
          this.regionShiPicker = true;
        } else {
          this.$toast("请选择上一级");
        }
      }
    },
    onSaveShiCode(data) {
      this.regionShiPicker = false;
      this.projectData.regionCode = data.code;
      this.projectData.regionLevel = data.levels;
      this.projectData.regionName = data.regionName;
      this.regionShiCode = data.code;
      this.regionShiName = data.regionName;
      this.regionXianCode = "";
      this.regionXianName = "";
      this.getXianList();
    },
    checkXianPicker() {
      if (this.editType) {
        if (this.regionShiCode) {
          this.regionXianPicker = true;
        } else {
          this.$toast("请选择上一级");
        }
      }
    },
    onSaveXianCode(data) {
      this.regionXianPicker = false;
      this.regionXianName = data.regionName;
      this.projectData.regionCode = data.code;
      this.projectData.regionLevel = data.levels;
      this.projectData.regionName = data.regionName;
    },
    getShengList() {
      let _this = this;
      _this.$api.project.openShengList().then((res) => {
        if (res.code == "1" && res.data != null) {
          _this.regionShengList = res.data;
        }
      });
    },
    getShiList() {
      let _this = this;
      _this.$api.project
        .linkageList({ parentCode: _this.regionShengCode })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.regionShiList = res.data;
          }
        });
    },
    getXianList() {
      let _this = this;
      _this.$api.project
        .linkageList({ parentCode: _this.regionShiCode })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.regionXianList = res.data;
          }
        });
    },
    //项目类容
    //项目类型
    checkProjectLxPicker() {
      if (this.editType) {
        this.projectLxPicker = true;
      }
    },
    onSaveProjectLx(data) {
      this.projectLxPicker = false;
      this.projectLxName = data.dictName;
      this.projectData.projectType = data.dictCode;

      this.getProjectLxList(2, data.dictCode);
      this.projectDlName = "";
      this.projectData.mainClass = "";
      this.projectXfName = "";
      this.projectData.subClass = "";
    },
    //项目大类
    checkProjectDlPicker() {
      if (this.editType) {
        if (this.projectData.projectType) {
          this.projectDlPicker = true;
        } else {
          this.$toast("请先选择项目性质");
        }
      }
    },
    onSaveProjectDl(data) {
      this.projectDlPicker = false;
      this.projectDlName = data.dictName;
      this.projectData.mainClass = data.dictCode;
      this.getProjectLxList(3, data.dictCode);
      this.projectXfName = "";
      this.projectData.subClass = "";
    },
    //项目细分
    checkProjectXfPicker() {
      if (this.editType) {
        if (this.projectData.mainClass) {
          this.projectXfPicker = true;
        } else {
          this.$toast("请先选择项目大类");
        }
      }
    },
    onSaveProjectXf(data) {
      let _this = this;
      this.projectXfPicker = false;
      this.projectXfName = data.dictName;
      this.projectData.subClass = data.dictCode;
      if (
        data.dictCode &&
        _this.projectData.projectAmount &&
        _this.projectData.cooperationAmount &&
        _this.projectData.laborAmount &&
        _this.projectData.purchaseAmount
      ) {
        _this.getPercentConfig();
      }
      // if (this.projectData.projectAmount) {
      //   this.getPercentConfig();
      // }
    },

    getProjectLxList(type, code) {
      let _this = this;
      _this.$api.project.itemList({ parentCode: code }).then((res) => {
        if (res.code == "1" && res.data != null) {
          if (type == "1") {
            _this.projectLxList = res.data;
          } else if (type == "2") {
            _this.projectDlList = res.data;
          } else if (type == "3") {
            _this.projectXfList = res.data;
          }
        }
      });
    },
    //项目进度
    checkProjectJdPicker() {
      if (this.editType) {
        this.proportionFlag = true;
      }
    },
    closeProportionPage() {
      this.proportionFlag = false;
    },
    setMoreProportion(data) {
      if (data[0]) {
        let nameArr = [],
          idsArr = [];
        data.forEach((item) => {
          nameArr.push(item.stageName);
          idsArr.push(item.id);
        });
        this.projectNodeNames = nameArr.join(",");
        this.$set(this.projectData, "projectNode", idsArr);
      } else {
        this.$set(this.projectData, "projectNode", []);
        this.projectNodeNames = "";
      }

      this.proportionFlag = false;
    },
    //获取外业比例
    // getExteriorPercent(val) {
    //   if (val < 0 || val > 100) {
    //     this.$toast("百分比不能大于100或者小于0");
    //     this.projectData.interiorPercent = "";
    //     this.projectData.exteriorPercent = "";
    //   } else {
    //     this.projectData.exteriorPercent = 100 - parseInt(val);
    //   }
    // },
    // checkPercentage(val, type) {
    //   if (val < 0 || val > 100) {
    //     this.$toast("成本百分比不能大于100或者小于0");
    //     if (type == "marketPercent") {
    //       this.projectData.marketPercent = "5";
    //     } else if (type == "technologyPercent") {
    //       this.projectData.technologyPercent = "5";
    //     } else {
    //       this.projectData.receptionPercent = "3";
    //     }
    //   } else {
    //     if (type == "marketPercent") {
    //       this.projectData.marketPercent = val;
    //     } else if (type == "technologyPercent") {
    //       this.projectData.technologyPercent = val;
    //     } else {
    //       this.projectData.receptionPercent = val;
    //     }
    //   }
    // },
    //招标方式
    checkBiddingPicker() {
      if (this.editType) {
        this.biddingTypePicker = true;
      }
    },
    onSaveBiddingType(data) {
      this.biddingTypePicker = false;
      this.projectData.biddingType = data.dictCode;
      this.biddingTypeName = data.dictName;
    },
    getZbfsList() {
      let _this = this;
      _this.$api.project
        .itemList({ parentCode: "xiangmuchengjiefangshi" })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.biddingList = res.data;
          }
        });
    },
    getProjectType() {
      let _this = this;
      _this.$api.project.itemList({ parentCode: "XMZT" }).then((res) => {
        if (res.code == "1" && res.data != null) {
          res.data.forEach((item) => {
            if (item.enable) {
              _this.projectStatusColumns.push(item);
            }
          });
        }
      });
    },
    /*获取时间控件*/
    TimePicker(type) {
      if (this.editType) {
        this.checkTimeIndex = type;
        this.showTimePicker = true;
      }
    },
    /*获取时间数据*/
    onTimeConfirm(data) {
      this.showTimePicker = false;
      if (this.checkTimeIndex == "1") {
        this.$set(
          this.projectData,
          "startDate",
          dateTimeFormat(data).substr(0, 10)
        );
      } else if (this.checkTimeIndex == "2") {
        this.$set(
          this.projectData,
          "expectedFinishDate",
          dateTimeFormat(data).substr(0, 10)
        );
      } else {
        this.$set(
          this.projectData,
          "ownerFirstTime",
          dateTimeFormat(data).substr(0, 10)
        );
      }
    },
    //获取是否审核
    checkIsTypePicker(type) {
      if (this.editType) {
        this.checkWhetherIndex = type;
        this.isTypePicker = true;
      }
    },
    onIsTypeConfirm(data) {
      this.isTypePicker = false;
      if (this.checkWhetherIndex == "1") {
        this.projectData.isAudit = data.dictCode;
        this.isAuditName = data.dictName;
      } else if (this.checkWhetherIndex == "2") {
        this.projectData.isReview = data.dictCode;
        this.isReviewName = data.dictName;
      } else if (this.checkWhetherIndex == "3") {
        this.projectData.isPerformanceBond = data.dictCode;
        this.isPerformance = data.dictName;
      } else if (this.checkWhetherIndex == "waidiao") {
        this.projectData.isDiversion = data.dictCode;
        this.isDiversionName = data.dictName;
      }
    },

    //项目负责人
    checkRedioRetinuePicker(type) {
      this.peopleRedioType = type;
      if (this.editType) {
        this.showRedioRetinuePicker = true;
      }
    },
    setRedioRetinue(data) {
      if (data != "") {
        if (this.peopleRedioType == "headName") {
          this.projectData.headName = data.realName;
          this.projectData.head = data.id;
        }
      }
      this.showRedioRetinuePicker = false;
    },
    //项目成员
    checkMoreRetinuePicker(type) {
      this.moreSelectType = type;
      if (this.editType) {
        this.showMoreRetinuePicker = true;
      }
    },
    setMoreRetinue(data) {
      this.projectData.member = [];
      this.moreRetinueList = [];
      let newArr = JSON.parse(window.sessionStorage.getItem("moreRetinueList"));
      newArr.forEach((item) => {
        this.moreRetinueList.push(item);
        this.projectData.member.push(item.id);
      });

      this.showMoreRetinuePicker = false;
    },
    delStaff(data) {
      //删除项目成员

      this.projectData.member.forEach((item, index) => {
        if (item == data.id) {
          this.projectData.member.splice(index, 1);
          this.moreRetinueList.splice(index, 1);
          // sessionStorage

          window.sessionStorage.setItem(
            "moreRetinueList",
            JSON.stringify(this.moreRetinueList)
          );
        }
      });
    },

    setMoreStaff(dataArr) {
      //项目承接人 undertakeList
      let _this = this;
      let newArr = [];
      if (dataArr[0]) {
        if (this.projectData.undertakeList[0]) {
          let oldArr = this.projectData.undertakeList;
          dataArr.forEach((item) => {
            item.uid = item.id;
            oldArr.forEach((oldItem) => {
              if (item.uid == oldItem.uid) {
                item.proportion = oldItem.proportion;
              }
            });
            newArr.push({
              uid: item.id,
              realName: item.realName,
              proportion: item.proportion ? item.proportion : 0,
            });
          });
          console.log(newArr, "newArr");
        } else {
          dataArr.forEach((item) => {
            let childItem = {
              uid: item.id,
              realName: item.realName,
              proportion: 0,
            };

            newArr.push(childItem);
          });
        }

        _this.projectData.undertakeList = JSON.parse(JSON.stringify(newArr));
      } else {
        this.$set(this.projectData, "undertakeList", []);
      }

      _this.undertakeIds = [];
      _this.projectData.undertakeList.forEach((item) => {
        _this.undertakeIds.push(item.uid);
      });

      this.showMoreRetinuePicker = false;
    },
    delUndertakeItem(delIndex) {
      //删除承接人
      let _this = this;
      _this.undertakeIds = [];

      _this.projectData.undertakeList.splice(delIndex, 1);
      _this.projectData.undertakeList.forEach((item) => {
        _this.undertakeIds.push(item.uid);
      });
    },
    closeStaffPage() {
      this.showMoreRetinuePicker = false;
    },
    checkProportion() {
      if (parseFloat(this.projectData.proportion) > 100) {
        this.$toast("分配比例不得大于100%");
        this.projectData.proportion = "";
      }
    },
    checkPhone() {
      let phone = this.projectData.ownerMobile;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$toast("请填写正确的手机号码");
        this.projectData.ownerMobile = "";
      }
    },
    //校验商务费
    checkHzf() {
      // let _this = this;
      // if (
      //   Number(_this.projectData.cooperationAmount) >
      //   Number(_this.projectData.projectAmount)
      // ) {
      //   _this.$toast("商务费不能大于项目金额!");
      //   _this.projectData.cooperationAmount = "";
      //   _this.projectData.proportion = 0;
      // } else {
      //   _this.$set(
      //     _this.projectData,
      //     "proportion",
      //     parseFloat(
      //       ((_this.projectData.projectAmount -
      //         _this.projectData.cooperationAmount) /
      //         _this.projectData.projectAmount) *
      //       100
      //     ).toFixed(2)
      //   );
      //   //  projectData.proportion
      // }
      let _this = this,
        projectAmount = Number(_this.projectData.projectAmount)
          ? Number(_this.projectData.projectAmount)
          : 0, //项目金额
        cooperationAmount = Number(_this.projectData.cooperationAmount)
          ? Number(_this.projectData.cooperationAmount)
          : 0, //商务费
        laborAmount = Number(_this.projectData.laborAmount)
          ? Number(_this.projectData.laborAmount)
          : 0, //技术协作费
        purchaseAmount = Number(_this.projectData.purchaseAmount)
          ? Number(_this.projectData.purchaseAmount)
          : 0, //硬件采购费
        diversionAmount = Number(_this.projectData.diversionAmount)
          ? Number(_this.projectData.diversionAmount)
          : 0; //内部外调费

      if (projectAmount <= 0) {
        _this.projectData.proportion = "";
        _this.projectData.marketPercent = "";
        _this.projectData.technologyPercent = "";
        _this.projectData.receptionPercent = "";
        _this.$toast("项目金额必须大于0!");
        return;
      }
      if (cooperationAmount > projectAmount) {
        _this.projectData.proportion = "";
        _this.projectData.marketPercent = "";
        _this.projectData.technologyPercent = "";
        _this.projectData.receptionPercent = "";
        _this.$toast("商务费不能大于项目金额!");
        return;
      }
      if (laborAmount > projectAmount) {
        _this.projectData.proportion = "";
        _this.projectData.marketPercent = "";
        _this.projectData.technologyPercent = "";
        _this.projectData.receptionPercent = "";
        _this.$toast("技术协作费不能大于项目金额!");
        return;
      }
      if (purchaseAmount > projectAmount) {
        _this.projectData.proportion = "";
        _this.projectData.marketPercent = "";
        _this.projectData.technologyPercent = "";
        _this.projectData.receptionPercent = "";
        _this.$toast("硬件采购费不能大于项目金额!");
        return;
      }
      if (diversionAmount > projectAmount) {
        _this.projectData.proportion = "";
        _this.projectData.marketPercent = "";
        _this.projectData.technologyPercent = "";
        _this.projectData.receptionPercent = "";
        _this.$toast("内部外调费不能大于项目金额!");
        return;
      }

      if (
        Number(
          cooperationAmount + laborAmount + purchaseAmount + diversionAmount
        ).toFixed(2) > projectAmount
      ) {
        _this.projectData.proportion = "";
        _this.projectData.marketPercent = "";
        _this.projectData.technologyPercent = "";
        _this.projectData.receptionPercent = "";
        _this.$toast(
          "商务费+技术协作费+硬件采购费+内部外调费不能大于项目金额!"
        );
        return;
      }
      // 我方分配占比=（项目金额-商务费-技术协作费-硬件采购费）/项目金额*100%
      _this.$set(
        _this.projectData,
        "proportion",
        parseFloat(
          ((projectAmount - cooperationAmount - laborAmount - purchaseAmount) /
            projectAmount) *
            100
        ).toFixed(2)
      );
      // if (_this.projectData.subClass) {

      //   _this.getPercentConfig(
      //     _this.projectData.subClass,
      //     projectAmount,
      //     cooperationAmount,
      //     laborAmount,
      //     purchaseAmount
      //   );
      // }
    },
    //获取项目成本比例
    getPercentConfig() {
      let _this = this;
      if (
        _this.projectData.subClass &&
        _this.projectData.projectAmount &&
        _this.projectData.cooperationAmount &&
        _this.projectData.laborAmount &&
        _this.projectData.purchaseAmount &&
        _this.projectData.diversionAmount
      ) {
        _this.$api.project
          .getConfig({
            projectAmount: _this.projectData.projectAmount,
            projectSubClass: _this.projectData.subClass,
            cooperationAmount: _this.projectData.cooperationAmount,
            laborAmount: _this.projectData.laborAmount,
            purchaseAmount: _this.projectData.purchaseAmount,
            diversionAmount: _this.projectData.diversionAmount,
          })
          .then((res) => {
            if (res.code == "1" && res.data != null) {
              _this.$set(
                _this.projectData,
                "marketPercent",
                res.data.marketPercent
              ); //营销成本比例
              _this.$set(
                _this.projectData,
                "technologyPercent",
                res.data.technologyPercent
              ); //技术成本比例
              _this.$set(
                _this.projectData,
                "receptionPercent",
                res.data.receptionPercent
              ); //招待成本比例
            }
          });
      }
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    /*提交表单*/
    checkInput(msg) {
      let _this = this;
      /*校验*/

      if (
        _this.projectData.projectAmount &&
        _this.projectData.cooperationAmount &&
        _this.projectData.laborAmount &&
        _this.projectData.purchaseAmount &&
        !_this.projectData.proportion
      ) {
        // 我方分配占比=（项目金额-商务费-技术协作费-硬件采购费）/项目金额*100%
        _this.$set(
          _this.projectData,
          "proportion",
          (
            parseFloat(
              (_this.projectData.projectAmount -
                _this.projectData.cooperationAmount -
                _this.projectData.laborAmount -
                _this.projectData.purchaseAmount) /
                projectAmount
            ) * 100
          ).toFixed(2)
        );
      }

      if (
        _this.projectData.projectName &&
        _this.projectData.projectStatus &&
        _this.projectData.projectAmount &&
        _this.projectData.kpiAmount &&
        _this.projectData.proportion &&
        _this.projectData.regionCode &&
        _this.projectData.regionLevel &&
        _this.projectData.regionName &&
        _this.projectData.projectType &&
        _this.projectData.mainClass &&
        _this.projectData.subClass &&
        _this.projectNodeNames &&
        _this.projectData.biddingType &&
        _this.projectData.startDate &&
        _this.projectData.expectedFinishDate &&
        _this.isAuditName &&
        _this.isReviewName &&
        // _this.projectData.head &&
        _this.projectData.ownerCompany &&
        _this.projectData.ownerContact &&
        _this.projectData.ownerMobile &&
        _this.projectData.interiorPercent &&
        _this.projectData.exteriorPercent &&
        _this.projectData.marketPercent &&
        _this.projectData.technologyPercent &&
        _this.projectData.receptionPercent &&
        _this.projectData.cooperationAmount &&
        _this.projectData.laborAmount &&
        _this.projectData.purchaseAmount &&
        _this.projectData.diversionAmount &&
        _this.isDiversionName &&
        _this.isPerformance &&
        _this.projectData.marketBonusPercent &&
        _this.projectData.technologyBonusPercent &&
        _this.projectData.undertakeList.length > 0
      ) {
        if(_this.projectData.kpiAmount<0){
          _this.$toast("业绩指标金额不能小于0");
          return false
        }
        if (this.projectData.projectNode.length > 1) {
          let totalProportion = 0;
          _this.projectData.undertakeList.forEach((item) => {
            totalProportion += Number(item.proportion);
          });
          console.log(totalProportion, "totalProportion项目承接人比例");
          if (Number(totalProportion) == "100") {
            _this.mode = msg;
            _this.saveAll();
          } else {
            _this.$toast("项目承接人比例之和必须等于100");
          }
        } else {
          _this.$toast("项目进度配置至少为2个");
        }
      } else {
        console.log(_this.projectData, " _this.projectData");
        _this.$toast("带星号为必填，不能为空");
      }
    },
    /*保存接口*/
    saveAll() {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.project
        .addProjectApply(_this.mode, _this.projectData)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          _this.$toast("网络失败，稍后重试");
          _this.btnLoading = false;
        });
    },
    /*撤回/删除*/
    delApply() {
      let _this = this;

      let msg = _this.projectData.verifyStatus == "hold" ? "删除" : "撤回";
      _this.$dialog
        .confirm({
          title: "确认" + msg,
          message: "您确认要" + msg + "当前申请?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.project
            .backProjectApply(
              _this.projectData.verifyStatus,
              _this.projectData.id
            )
            .then((res) => {
              if (res.code == "1") {
                let text = msg + "成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              _this.$toast("网络失败，稍后重试");
              _this.btnLoading = false;
            });
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo(data) {
      // if (this.mode == "add" && data && data.realName) {
      //     this.$set(this.projectData, "firstContact", [data.id]);
      //     this.$set(this.projectData, "firstContactName", data.realName);
      //     window.sessionStorage.setItem(
      //         "morePeopleList",
      //         JSON.stringify(this.projectData.firstContact)
      //     );
      // }
    },
  },
};
</script>

<style lang="less">
.projectRegisterPage {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding-bottom: 75px;
  .smallText {
    width: 100%;
    padding: 3px 16px;
    font-size: 12px;
    line-height: 16px;
  }
  .red {
    color: red;
  }
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 5px; // overflow-y: initial;
  }
  .baseNone {
    border-bottom: 1px solid #f6f6f6;
    .van-cell__title {
      span {
        font-size: 15px;
        color: #323233;
      }
    }
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
        font-size: 15px;
      }
      .van-field__control:disabled {
        color: #969799;
        -webkit-text-fill-color: #969799;
      }
    }
  }
  > h4 {
    position: relative;
    border-bottom: 1px solid #e0e0e0;
    line-height: 45px;
    padding: 0 20px;
    font-weight: 700;
    color: #2581d6;
    font-size: 15px;
    z-index: 10;
    background-color: #fff;
  }
  > h4:before {
    content: "";
    position: absolute;
    width: 5px;
    height: 25px;
    background: #2581d6;
    top: 10px;
    left: 10px;
    bottom: 5px;
  }
  .itemPerson {
    textarea {
      text-align: right;
    }
  }
  .baseNone::after {
    content: none;
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 190px;
      }
    }
  } //项目成员样式
  .selectCyMain {
    min-height: 85px;
    border-bottom: 1px solid #f6f6f6 !important;
    box-sizing: border-box;
    .ggInput.van-cell::after {
      content: none;
    }
    .cyListBox {
      width: 100%;
      padding: 0 16px;
      ul {
        width: 100%;
        li {
          float: left;
          width: 25%;
          margin-bottom: 10px;
          dl {
            width: 100%;
            height: 65px;
            position: relative;
            dt {
              margin: 0 auto;
              width: 45px;
              height: 45px;
              border-radius: 50%;
              -webkit-border-radius: 50%;
              -moz-border-radius: 50%;
            }
            dd {
              margin-top: 3px;
              text-align: center;
              font-size: 14px;
              color: #969799;
            }
          }
        }
        li.cyList {
          dt {
            img {
              width: 45px;
              height: 45px;
              border-radius: 50%;
              -webkit-border-radius: 50%;
              -moz-border-radius: 50%;
            }
          }
          dd.delStaff {
            margin: 0;
            width: 20px;
            height: 20px;
            line-height: 20px;
            border-radius: 50%;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border: 1px solid red;
            color: red;
            font-size: 14px;
            text-align: center;
            position: absolute;
            top: -8px;
            right: 17px;
            box-sizing: border-box;
          }
        }
        li.addBtn {
          dt {
            width: 45px;
            height: 45px;
            border-radius: 50%;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            img {
              max-width: 45px;
              border-radius: 50%;
              -webkit-border-radius: 50%;
              -moz-border-radius: 50%;
            }
          }
        }
      }
    }
  }
  .selectCyMain.baseNone {
    border: 0 none;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  } //项目承接人
  .undertakeBox {
    position: relative;
    .addBtn {
      position: absolute;
      top: 6px;
      right: 15px;
      border-radius: 8px;
      font-size: 12px;
    }
    .undertakeItem {
      width: 80%;
      margin: 10px auto;
      border: 1px solid #eee;
      border-radius: 8px;
      position: relative;
      .delBtn {
        display: inline-block;

        border-radius: 50%;
        border: 1px solid red;
        text-align: center;

        position: absolute;
        top: -6px;
        right: -6px;
        .van-icon {
          padding: 2px 2px;
          color: red;
        }
      }
    }
  } //审批记录样式
  .approveList {
    margin-top: 10px;
  } //流程图样式
  .flowList {
    margin-top: 10px;
  }
}

.tit {
  position: relative;
  padding: 0 16px 0 25px;
  font-size: 15px;
  height: 45px;
  line-height: 45px;
  position: relative;
  color: #2581d6;
  font-weight: 700;
  border-bottom: 1px solid #e0e0e0;
}

.tit:before {
  content: "";
  position: absolute;
  width: 5px;
  height: 21px;
  background: #2581d6;
  top: 12px;
  left: 16px;
}
</style>